import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import all translation namespaces
import commonEN from './locales/en/common.json';
import commonFR from './locales/fr/common.json';
import commonIT from './locales/it/common.json';

import fileFolderEN from './locales/en/FileFolder.json';
import fileFolderFR from './locales/fr/FileFolder.json';
import fileFolderIT from './locales/it/FileFolder.json';

import incitativeConsultingEN from './locales/en/IncitativeConsulting.json';
import incitativeConsultingFR from './locales/fr/IncitativeConsulting.json';
import incitativeConsultingIT from './locales/it/IncitativeConsulting.json';

import loggingOperationsEN from './locales/en/LoggingOperations.json';
import loggingOperationsFR from './locales/fr/LoggingOperations.json';
import loggingOperationsIT from './locales/it/LoggingOperations.json';

import modelsFormEN from './locales/en/ModelsForm.json';
import modelsFormFR from './locales/fr/ModelsForm.json';
import modelsFormIT from './locales/it/ModelsForm.json';

import modelsListEN from './locales/en/ModelsList.json';
import modelsListFR from './locales/fr/ModelsList.json';
import modelsListIT from './locales/it/ModelsList.json';

import modelsTablesEN from './locales/en/ModelsTables.json';
import modelsTablesFR from './locales/fr/ModelsTables.json';
import modelsTablesIT from './locales/it/ModelsTables.json';

import notionEN from './locales/en/Notion.json';
import notionFR from './locales/fr/Notion.json';
import notionIT from './locales/it/Notion.json';

import reusableComponentsEN from './locales/en/ReusableComponents.json';
import reusableComponentsFR from './locales/fr/ReusableComponents.json';
import reusableComponentsIT from './locales/it/ReusableComponents.json';

import productClientFormsEN from './locales/en/product_customer_forms.json';
import productClientFormsFR from './locales/fr/product_customer_forms.json';
import productClientFormsIT from './locales/it/product_customer_forms.json';

import productPartnerFormsEN from './locales/en/product_partner_forms.json';
import productPartnerFormsFR from './locales/fr/product_partner_forms.json';
import productPartnerFormsIT from './locales/it/product_partner_forms.json';

import productAdminFormsEN from './locales/en/product_admin_forms.json';
import productAdminFormsFR from './locales/fr/product_admin_forms.json';
import productAdminFormsIT from './locales/it/product_admin_forms.json';

import settingsEN from './locales/en/Settings.json';
import settingsFR from './locales/fr/Settings.json';
import settingsIT from './locales/it/Settings.json';

import digitalCIEN from './locales/en/DigitalCI.json';
import digitalCIFR from './locales/fr/DigitalCI.json';
import digitalCIIT from './locales/it/DigitalCI.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: commonEN,
        FileFolder: fileFolderEN,
        DigitalCI: digitalCIEN,
        IncitativeConsulting: incitativeConsultingEN,
        LoggingOperations: loggingOperationsEN,
        ModelsForm: modelsFormEN,
        ModelsList: modelsListEN,
        ModelsTables: modelsTablesEN,
        Notion: notionEN,
        ReusableComponents: reusableComponentsEN,
        product_customer_forms: productClientFormsEN,
        product_partner_forms: productPartnerFormsEN,
        product_admin_forms: productAdminFormsEN,
        Settings: settingsEN,
      },
      fr: {
        common: commonFR,
        FileFolder: fileFolderFR,
        DigitalCI: digitalCIFR,
        IncitativeConsulting: incitativeConsultingFR,
        LoggingOperations: loggingOperationsFR,
        ModelsForm: modelsFormFR,
        ModelsList: modelsListFR,
        ModelsTables: modelsTablesFR,
        Notion: notionFR,
        ReusableComponents: reusableComponentsFR,
        product_customer_forms: productClientFormsFR,
        product_partner_forms: productPartnerFormsFR,
        product_admin_forms: productAdminFormsFR,
        Settings: settingsFR,
      },
      it: {
        common: commonIT,
        FileFolder: fileFolderIT,
        DigitalCI: digitalCIIT,
        IncitativeConsulting: incitativeConsultingIT,
        LoggingOperations: loggingOperationsIT,
        ModelsForm: modelsFormIT,
        ModelsList: modelsListIT,
        ModelsTables: modelsTablesIT,
        Notion: notionIT,
        ReusableComponents: reusableComponentsIT,
        product_customer_forms: productClientFormsIT,
        product_partner_forms: productPartnerFormsIT,
        product_admin_forms: productAdminFormsIT,
        Settings: settingsIT,
      },
    },
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: [
      'common',
      'FileFolder',
      'DigitalCI',
      'IncitativeConsulting',
      'LoggingOperations',
      'ModelsForm',
      'ModelsList',
      'ModelsTables',
      'Notion',
      'ReusableComponents',
      'product_customer_forms',
      'product_partner_forms',
      'product_admin_forms',
      'Settings',
    ],
    supportedLngs: ['en', 'fr', 'it'],
    load: 'languageOnly',
    interpolation: { escapeValue: false },

    detection: {
      // Try first in localStorage, then in cookie, then in navigator, then in <html lang="">
      order: ['localStorage', 'cookie', 'navigator', 'htmlTag'],
      // keys used for detection / cache
      lookupLocalStorage: 'i18nextLng',
      lookupCookie: 'i18next',

      // Activate caching in localStorage and cookie
      caches: ['localStorage', 'cookie'],

      cookieMinutes: 60 * 24 * 30,
      cookieDomain: window.location.hostname,
    },
    saveMissing: true,
    missingKeyHandler: function (lng, ns, key) {
      // Here we can just log or write to a file, depending on the context
      if (process.env.NODE_ENV === 'development') {
        console.warn(`[i18n] Clé manquante : ${ns}:${key} (${lng})`);
      }
    },
  });

export default i18n;
